export default {
  primary: '#19182c',
  light: '#F0F2EC',
  mediumLight: '#A698B5',
  medium: '#3577F7',
  mediumDark: '#FF0000',
  dark: '#19182C',
}
